import { render } from "./AsideFavorite.vue?vue&type=template&id=44d34d9e&scoped=true"
import script from "./AsideFavorite.vue?vue&type=script&lang=js"
export * from "./AsideFavorite.vue?vue&type=script&lang=js"

import "./AsideFavorite.vue?vue&type=style&index=0&id=44d34d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d34d9e"],['__file',"src/components/favorite/AsideFavorite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44d34d9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44d34d9e', __exports__)) {
    api.reload('44d34d9e', __exports__)
  }
  
  module.hot.accept("./AsideFavorite.vue?vue&type=template&id=44d34d9e&scoped=true", () => {
    api.rerender('44d34d9e', render)
  })

}


export default __exports__